<template>
</template>

<script>
export default {
    components: {
    },
    props: {
        item: {
            type: Object
        },
        width: {
            type: Number
        },
        height: {
            type: Number
        },
        borderWidth: {
            type: Number
        },
        isDesktop: {
            type: Boolean
        },
        numeration:{
            type: Boolean
        },
        type: {
            type: String
        },
        inViewPort: {
            type: Boolean
        },
        fnGotoUrl:{
            type: Function
        },
        isHoverandZoomActivated:{
            type: Boolean,
            default: false
        },
        position:{
            type: Number
        },
        snap:{
            type: Number
        },
        zoomDetails:{
            type: Boolean,
            default: false
        }
    },
    data(){
        return {
            currentTime: 0,
            alreadyAppear:false
        };
    },
    mounted() {
    },
    watch:{
        inViewPort(newVal, oldVal){
            if(!this.video){
                return;
            }
            let currentTime = this.getCurrentTime();
            if(oldVal && !newVal && currentTime !== null){
                this.currentTime = currentTime;
            }
        }
    },
    computed: {
        video() {
            if(!this.alreadyAppear){
                return null;
            }
            let video = this.item?.video ?? null;
            if (!video) {
                return null;
            }
            return {
                source: video,
                sourceFull: video,
                poster: this.item.image
            };
        }
    },
    methods: {
        visibilityChanged(isVisible){
            if(isVisible){
                this.alreadyAppear = true;
            }
        },
        getCurrentTime(){
            let video = this.$el.querySelector("video");
            if(video){
                return video.currentTime;
            }
            return null;
        },
    },
}
</script>